import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'dashboard-chat-list',
  templateUrl: './chat-list.component.html',
  styleUrls: ['./chat-list.component.scss'],
})
export class ChatListComponent implements OnInit {
  @Input() mode: string = 'content';

  toolTip: string = '';
  
  constructor() { }

  ngOnInit() {}

}
